import { configureStore as createRTKStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';

import { initializeFromLocalStorage } from 'actions/localStorage';
import analyticsMiddleware from 'middleware/analytics';
import basketDirty from 'middleware/basketDirty';
import errorLoggingMiddleware from 'middleware/errorLogging';
import localStorageMiddleware from 'middleware/localStorage';
import messagesMiddleware from 'middleware/messages';
import twoStageBasketDirty from 'middleware/twoStageBasketDirty';
import reducer from 'reducers';
import RequestService from 'services/RequestService';

export function configureStore(preloadedState) {
  const customMiddlewares = [
    errorLoggingMiddleware,
    analyticsMiddleware,
    messagesMiddleware,
    localStorageMiddleware,
    basketDirty,
    twoStageBasketDirty,
  ];

  if (REDUX_LOGGING) customMiddlewares.push(logger);

  const store = createRTKStore({
    reducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: { requestService: RequestService },
        },
        serializableCheck: false,
      }).concat(customMiddlewares),
    preloadedState,
    devTools: REDUX_LOGGING,
  });

  store.dispatch(initializeFromLocalStorage());
  return store;
}

export function getStore() {
  if (!window.homeChefStore) {
    window.homeChefStore = configureStore();
  }

  return window.homeChefStore;
}
